import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-fetch-client';
import { AuthService } from 'pages/login/service';
import toastr from 'toastr';
import { apiEndpoint } from 'startup/environment';

@inject(HttpClient, AuthService)
export class Setup {
    constructor(http, authService) {
        this.http = http;
        this.authService = authService;
    }

    configureFetch() {
        this.http.configure(config => {
            config
            .withBaseUrl(apiEndpoint())
            .withInterceptor({
                request: async request => {
                    request.headers.set('Authorization', `Bearer ${this.authService.user.token}`);
                    request.headers.set('Db', this.authService.user.database);
                    return request;
                },
                response: async response => {
                    const thirtyMinutes = 30 * 60 * 1000; // 30 minutes in milliseconds
                    switch(response.status) {
                        case 200:
                            break;
                        case 401:
                            await this.authService.login(false);
                            toastr.error('Please login to continue');
                            throw new Error('Not Authorized');
                        case 403:
                            toastr.error('You do not have access to this section');
                            throw new Error('Not Authorized');
                        case 404:
                            return null;
                        case 400:
                        case 422: {
                            const data = await response.json();
                            const msg = data.Message || data.message;
                            if(msg)
                                toastr.error(msg.replace(/(?:\r\n|\r|\n)/g, '<br />'));
                            throw new Error(msg);
                        }
                        case 500:
                            toastr.error('Something went wrong. If this error continues, please contact support.');
                            throw new Error('Something went wrong. If this error continues, please contact support.');
                    }

                    return response;
                }
            });
        });
    }
}